import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    IAgentUserProfileRegistrationClient,
} from 'interfaceAdapter/gatewaySchemas/IAgentUserProfileRegistrationClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

const PATH = `${API_LOCATION_URL}/agent/registration/user_profile`;

export class AgentUserProfileRegistrationClient implements IAgentUserProfileRegistrationClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, agent_user } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-A': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify(agent_user);

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
